import { Component } from "@builder.io/sdk";

export const contactHomeConfig: Component = {
  name: "Contact Home (Home)",
};
